const styles = {
  headerRow: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 2,
  },
  pageTitle: {
    fontFamily: 'Source Sans Pro',
    fontWeight: 600,
    fontSize: { xs: '1.75rem', sm: '2.375rem' },
    lineHeight: '100%',
    color: '#5236AB',
  },
};

export default styles;
